<template>
  <v-navigation-drawer
    color="#F2F2F2"
    app elevation="0"
    :mini-variant.sync="rail"
    width="200"
    mini-variant-width="96"
    expand-on-hover
    floating
    style="overflow: visible"
  >
    <div class="app-drawer-content" :class="{ extended: !rail }">
      <div style="width: 100%;">
        <a href="/lk/" @click.stop style="margin: 40px 24px; display: block">
          <img
            alt="Логотип"
            src="/static/lk/logo.svg"
            height="48px"
          />
        </a>
      </div>

      <div class="mt-auto">
        <v-list-item class="drawer-list-item">
          <v-btn
            href="/lk/" class="nav-button" large
            depressed :color="getNavButtonColor(['home', 'deal'])" @click="rail = !rail"
          >
            <img alt="Заказы" src="/static/lk/img/label.svg">
            <span v-if="!rail" class="nav-button-text">Заказы</span>
          </v-btn>
        </v-list-item>
        <v-list-item class="drawer-list-item">
          <v-btn
            href="/lk/express/" class="nav-button" large
            depressed :color="getNavButtonColor(['express-home'])" @click="rail = !rail"
          >
            <img alt="Express-грузы" src="/static/lk/img/express.svg">
            <span v-if="!rail" class="nav-button-text">Express-грузы</span>
          </v-btn>
        </v-list-item>
        <v-list-item class="drawer-list-item">
          <v-btn
            href="/lk/invoices/" class="nav-button" large
            depressed :color="getNavButtonColor(['invoices'])" @click="rail = !rail"
          >
            <img alt="Счета" src="/static/lk/img/report.svg">
            <span v-if="!rail" class="nav-button-text">Счета</span>
          </v-btn>
        </v-list-item>
      </div>

      <div class="mt-auto">
        <v-list-item class="drawer-list-item" style="height: 81px">
          <div v-if="responsible && !rail" class="manager-data">
            <div class="manager-data-title">Мой менеджер</div>
            <div class="manager-data-name">{{ responsible.name }}</div>
            <div class="manager-data-contact">{{ responsible.phone }}</div>
            <div class="manager-data-contact">{{ responsible.email }}</div>
          </div>
        </v-list-item>
        <v-list-item class="drawer-list-item">
          <v-btn
            :href="responsibleEmailLink" class="nav-button" large
            depressed color="#0000000D"
          >
            <img alt="Написать" src="/static/lk/img/mail.svg">
            <span v-if="!rail" class="nav-button-text">Написать</span>
          </v-btn>
        </v-list-item>
        <v-list-item class="drawer-list-item">
          <v-btn
            :href="responsiblePhoneLink" class="nav-button" large
            depressed color="#0000000D"
          >
            <img alt="Позвонить" src="/static/lk/img/call.svg">
            <span v-if="!rail" class="nav-button-text">Позвонить</span>
          </v-btn>
        </v-list-item>
      </div>

      <div class="mt-auto" style="margin: 40px 24px;">
        <v-list-item class="drawer-list-item">
          <v-btn
            class="nav-button" href="/logout/"
            depressed color="#0000000D"
            @click.stop
          >
            <img
              alt="Выйти"
              src="/static/lk/img/power.svg"
              width="20px"
            />
            <span v-if="!rail" class="nav-button-text">Выйти</span>
          </v-btn>
        </v-list-item>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'AppDrawer',
  data() {
    return {
      rail: true,
    }
  },
  computed: {
    ...mapState(['client', 'responsible', 'unreadMessagesCount']),
    responsiblePhoneLink() {
      return (this.responsible && this.responsible.phone) ? `tel:${this.responsible.phone}` : null
    },
    responsibleEmailLink() {
      return (this.responsible && this.responsible.email) ? `mailto:${this.responsible.email}` : null
    },
  },
  watch: {
    rail: val => {
      if (val) {
        localStorage.setItem('appDrawerRail', '1')
      } else {
        localStorage.removeItem('appDrawerRail')
      }
    },
  },
  methods: {
    getNavButtonColor(views) {
      return views.indexOf(this.$route.name) > -1 ? '#00000026' : '#0000000D'
    },
  }
}
</script>

<style scoped>
.app-drawer-content {
  display: flex;
  flex-flow: column;
  align-items: center;
  height: 100%;
}

.nav-button {
  width: 100% !important;
  height: 48px !important;
  min-width: 48px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  border-radius: 12px;
}


.nav-button-text {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.002em;
  text-align: center;
  margin-left: 8px;
}

.extended .nav-button {
  width: 168px !important;
  justify-content: start !important;
}

.drawer-list-item {
  padding: 0 24px;
  min-height: 30px;
  margin-bottom: 8px;
}

.manager-data {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 20px;
}

.manager-data-title {
  font-weight: 500;
  font-size: 16px;
  color: #322E2E;
}

.manager-data-name {
  font-weight: 400;
  font-size: 14px;
  color: #322E2E;
}

.manager-data-contact {
  font-weight: 400;
  font-size: 12px;
  color: #322E2E80;
}
</style>
<style>
.v-navigation-drawer__content {
  overflow: hidden;
}
</style>